import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const onOut = () => setUser(null);
    window.addEventListener("ph:signout", onOut);
    if (!localStorage.getItem("ph_token")) {
      setLoading(false);
    } else {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {}).finally(() => setLoading(false));
    }
    return () => window.removeEventListener("ph:signout", onOut);
  }, []);

  const signIn = (token, u) => {
    localStorage.setItem("ph_token", token);
    setUser(u);
  };
  const signOut = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("ph_token");
    setUser(null);
  };

  return <Ctx.Provider value={{ user, loading, signIn, signOut }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
